import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_36() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter September 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            SBTi Releases Stricter Climate Rules for Power Sector to Meet Net
            Zero Targets.
          </title>
          <meta
            name="description"
            content="The Science Based Targets initiative (SBTi) has published a draft of its new Power Sector Net Zero Standard and launched a global public consultation."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          SBTi Releases Stricter Climate Rules for Power Sector to Meet Net Zero
          Targets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Sep_2025_1.webp")}
            alt="SBTi Releases Stricter Climate Rules for Power Sector to Meet Net Zero Targets."
            loading="lazy"
          />
        </figure>
        <p>
          The Science Based Targets initiative (SBTi) has published a draft of
          its new Power Sector Net Zero Standard and launched a global public
          consultation. The standard outlines specific steps for companies
          involved in electricity generation, distribution, storage, and retail
          to align with climate goals that aim to limit global warming to 1.5
          degrees Celsius. This draft replaces the 2020 quick-start guidance
          with a more structured and detailed framework that reflects current
          scientific findings and ties into the broader Corporate Net Zero
          Standard Version 2.0.
        </p>
        <p>
          The power sector remains one of the largest contributors to greenhouse
          gas emissions, accounting for nearly 40% of energy-related carbon
          output globally. As electrification spreads through sectors like
          transport, manufacturing, and buildings, the demand for clean
          electricity is expected to rise sharply. The International Energy
          Agency projects electricity will make up over half of final energy
          consumption by 2050, compared to just 20% in 2023. This transition is
          critical because electricity can shift to renewable sources more
          quickly than fossil fuels. However, progress has been inconsistent,
          with many utilities still heavily dependent on coal and natural gas.
        </p>
        <p>
          SBTi’s new standard introduces clearer requirements for reducing
          emissions across the full electricity value chain. It calls for
          companies to end new investments in coal and oil power and restrict
          new gas-fired capacity unless specific conditions are met. Companies
          must report key data, such as the share of electricity generated from
          low-carbon sources and emissions from transmission and storage losses.
          These updates aim to close long-standing gaps in climate action plans
          and create more consistency across the sector.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The standard will recalibrate how power companies define value,
            exposing stranded asset risk and demanding operational transparency
            beyond generation. Firms must internalize emissions as cost,
            embedding climate metrics into governance, procurement, and capital
            planning. Adaptation requires scenario modeling, dynamic asset
            portfolios, and internal carbon pricing mechanisms.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          FCA Assesses Climate Reporting Practices Across Financial Sector Firms
          in Multi-Firm Review.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Sep_2025_2.webp")}
              alt="FCA Assesses Climate Reporting Practices Across Financial Sector Firms in Multi-Firm Review."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The Financial Conduct Authority has published the results of a
          comprehensive multi-firm review evaluating how asset managers, life
          insurers, and regulated pension providers are meeting the UK’s
          climate-related disclosure rules. These rules, aligned with the Task
          Force on Climate-related Financial Disclosures, have led to a notable
          shift in how firms approach climate risks. Many firms now treat
          climate change as a material risk and are actively integrating climate
          considerations into their strategies, risk management practices, and
          investment decisions. The review also noted that firms have become
          more transparent in how they communicate these practices to clients
          and stakeholders.
        </p>
        <p>
          While overall progress is evident, the review identified several areas
          where there is room for improvement and greater efficiency. Firms
          reported that they were able to provide solid disclosures using
          historical data, such as carbon emissions, but faced challenges in
          generating forward-looking, scenario-based analysis due to limitations
          in data quality and methodology. At the product level, only around
          half of the reviewed reports included all three required climate
          scenarios, which impacts comparability. Additionally, product reports
          were often difficult for retail investors to find or interpret. Firms
          observed that although institutional clients benefit from detailed
          disclosures, retail audiences would be better served by more
          accessible and proportionate information formats. This has resulted in
          relatively low levels of engagement with product-level disclosures
          from individual investors.
        </p>
        <p>
          The review also surfaced the need to streamline reporting
          expectations, particularly as firms navigate multiple sustainability
          regimes. Asset managers expressed that overlapping requirements from
          both the current rules and the incoming Sustainability Disclosure
          Requirements create complexity and could be simplified. Firms further
          emphasized the importance of regulatory clarity, particularly as the
          UK moves toward aligning with international standards such as the
          ISSB. In response, the FCA has indicated its intention to review and
          refine the current framework, aiming to reduce administrative burdens,
          enhance the decision-usefulness of reports, and maintain the UK's
          leadership in global sustainable finance. This effort will include
          further engagement with industry stakeholders and collaboration with
          government bodies to ensure that the evolving sustainability reporting
          landscape supports consistent and practical outcomes across the
          investment chain.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The review shows that climate risk is becoming a core part of
            investment and risk management, with firms strengthening internal
            governance, integrating climate metrics into decision-making, and
            improving transparency at the entity level. As international
            standards like the ISSB framework gain traction, firms and
            regulators will need to prioritise clarity, consistency, and
            usability. For the industry, this signals a shift toward more
            structured, accountable, and investor-friendly reporting. It is
            likely to influence how products are designed, how data systems are
            built, and how firms communicate climate strategy to both
            institutional and retail audiences.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          The European Union is preparing a Circular Economy Act to reduce raw
          material waste and unify recycling markets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Sep_2025_3.webp")}
            alt="The European Union is preparing a Circular Economy Act to reduce raw material waste and unify recycling markets."
            loading="lazy"
          />
        </figure>
        <p>
          The European Commission has launched a formal consultation process for
          the upcoming Circular Economy Act, which is expected to be adopted by
          the end of 2026. This regulation aims to address the European Union’s
          limited progress on circularity, with the circularity rate increasing
          only slightly from 10.7 percent in 2010 to 11.8 percent in 2023. The
          Act seeks to create a more integrated market for waste and secondary
          raw materials, reduce regulatory fragmentation across Member States,
          and prioritise better recycling of electronic waste, the fastest
          growing waste stream in the EU.
        </p>
        <p>
          This initiative forms a key part of the European Union’s Clean
          Industrial Deal and Competitiveness Compass. It introduces several
          measures to boost the use of recycled materials, including revising
          end-of-waste criteria, expanding extended producer responsibility
          schemes, and implementing mandatory circular procurement standards.
          The regulation is designed to improve both the availability and
          affordability of high-quality recycled materials, making circular
          practices more economically viable across EU industries.
        </p>
        <p>
          In addition to reducing environmental harm, the Circular Economy Act
          is expected to support the EU’s goal of climate neutrality by 2050.
          Circular solutions could contribute up to 25 percent of the emissions
          reductions needed to meet this target. The Act also promotes job
          creation, particularly in small and medium-sized enterprises, and
          offers consumers access to more durable, repairable, and affordable
          products.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The Circular Economy Act will reshape industry fundamentals by
            embedding resource efficiency into core operations. From electronics
            to construction, sectors must align with circular principles,
            driving innovation in design, materials, and compliance. Long term,
            it fosters resilient supply chains, lowers input costs, and
            redefines competitiveness through sustainability-led industrial
            transformation across the EU.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          China Unveils Comprehensive Green Finance Taxonomy.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Sep_2025_4.webp")}
            alt="China Unveils Comprehensive Green Finance Taxonomy."
            loading="lazy"
          />
        </figure>
        <p>
          China has announced a new Green Finance Endorsed Project Catalogue
          that will come into effect on 1 October 2025. This unified taxonomy
          replaces multiple existing standards for green bonds and loans and is
          designed to bring consistency across financial markets. Developed
          jointly by the central bank, the financial regulatory authority, and
          the securities regulator, the new framework aims to reduce complexity
          for market participants, improve liquidity, and promote more efficient
          capital allocation toward environmentally sustainable activities.
        </p>
        <p>
          The updated taxonomy significantly expands the scope of green finance
          by including sectors such as environmental protection, energy
          efficiency, ecological restoration, green services, and urban
          infrastructure upgrades. It introduces new categories like green trade
          and green consumption to align financial flows with broader
          sustainability objectives. A notable addition is the classification
          for low-carbon transition activities in high-emission sectors, which
          is expected to facilitate the gradual decarbonisation of industries
          that are traditionally harder to abate.
        </p>
        <p>
          The framework takes a practical approach to transition finance by
          supporting activities that may not yet be fully green but are moving
          in that direction. For example, it includes projects that reduce
          methane emissions, improve energy efficiency in heavy industries, or
          shift transport systems toward lower emissions. It also provides
          technical criteria and eligibility thresholds to guide financial
          institutions, offering greater certainty to investors. It is also
          partially aligned with international taxonomies; the structure
          reflects China's emphasis on balancing environmental goals with
          industrial development.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To prepare for China’s unified Green Finance Taxonomy, financial
            institutions must upgrade internal ESG assessment frameworks to
            align with the new eligibility criteria, especially around
            transition finance. Sector-specific data analytics, lifecycle
            emissions modeling, and taxonomy-mapped risk tools will be
            essential. Firms that build technical expertise early, particularly
            in hard-to-abate sectors, will gain a competitive edge in
            underwriting credible green instruments and shaping the next phase
            of sustainable capital markets in China.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          The United States Launches a $500 Million Investment to Strengthen the
          Critical Minerals Supply Chain.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Sep_2025_5.webp")}
            alt="The United States Launches a $500 Million Investment to Strengthen the Critical Minerals Supply Chain."
            loading="lazy"
          />
        </figure>

        <p>
          The U.S. Department of Energy has announced up to one billion dollars
          in funding to strengthen domestic supply chains for critical minerals
          vital to clean energy, advanced manufacturing, and national security.
          This includes up to 500 million dollars for projects related to
          battery material processing, manufacturing, and recycling. An
          additional 250 million dollars is allocated to support the recovery of
          critical minerals from mining waste and industrial byproducts, 135
          million dollars for demonstration facilities focused on rare earth
          elements, and 50 million dollars to advance the refining of materials
          essential to the semiconductor industry.
        </p>
        <p>
          The program is designed to support technologies that are ready for
          commercial deployment or nearing scale-up, with a strong emphasis on
          near-term impact. It targets key supply chain vulnerabilities across
          sectors such as electric vehicles, grid energy storage, aerospace, and
          electronics. Each funding opportunity prioritizes environmental
          stewardship, labor standards, and permitting alignment, ensuring that
          projects adhere to sustainable and responsible development practices.
        </p>
        <p>
          This initiative places particular importance on innovation in mineral
          recovery from secondary sources and end-of-life products, reducing the
          need for new extraction. By supporting new methods in separation and
          purification, the strategy encourages the growth of advanced domestic
          capabilities that can respond to rising global demand. Companies that
          integrate clean processing technologies and circular economy
          principles are expected to benefit from both market opportunity and
          long-term policy support. These investments represent a decisive step
          toward building a resilient, low-emissions supply chain for the
          industries driving the energy transition.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Strategic investment in critical minerals reflects a deeper
            realignment of industrial strategy where these materials are no
            longer treated as just commodities but as foundational enablers of
            systemic transition. The emphasis on circular recovery and domestic
            processing suggests a shift toward material intelligence, designing
            supply chains that are adaptive, resource efficient, and decoupled
            from traditional extraction logic.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_36;
